import { api } from '@/lib/axios';
import type { Restaurant } from '@/types/restaurant';

/**
 * Restaurant Service
 *
 * Servicio para gestionar operaciones relacionadas con restaurantes (tenants).
 */
export const restaurantService = {
  /**
   * Obtiene los datos del restaurante actual basado en el tenant
   *
   * @returns Promise<Restaurant> Datos del restaurante
   * @throws Error si el restaurante no existe o hay un error de red
   */
  async getCurrentRestaurant(): Promise<Restaurant> {
    const { data } = await api.get<Restaurant>('/v1/admin/restaurant');
    return data;
  },
};
